import { FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { AppLink } from '@components';

import styles from './index.module.scss';

export const Footer: FC = () => {
	const { t } = useTranslation();

	return (
		<footer className={styles.footer}>
			<div className={`shell ${styles.shell}`}>
				<img src="/images/license.png" alt="Creative Commons License" width={102} height={26} />

				<div className={styles.text}>
					<p>
						<Trans
							defaults={t(
								'This work is licensed under a <a>Creative Commons Attribution-ShareAlike 4.0 International License</a>.'
							)}
							components={{
								a: <AppLink type="external" href="https://creativecommons.org/licenses/by-sa/4.0/" />
							}}
						/>
						{}
					</p>

					<p>
						{/* TODO: Add analytics or tracking code? */}
						<Trans
							defaults={t('powered by <a>dmarcian.com</a>')}
							components={{
								a: <AppLink type="external" href="https://dmarcian.com" />
							}}
						/>
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
